module.exports = __webpack_public_path__ + "media/images/noshis/iwainoshimihon-2a7b3c586ed317b822ad9608ff07f3c8.jpg";